import SetCssCustomProperties from "./modules/SetCssCustomProperties.js";
import ScrolledToggleElement from "./modules/ScrolledToggleElement.js";
import Menu from "./modules/Menu.js";
import SmoothScroll from "./modules/SmoothScroll.js";
// import TrimmingTexts from "./modules/TrimmingTexts.js";
import Modal from "./modules/Modal.js";
import Tab from "./modules/Tab.js";
import News from "./modules/News.js";
import InView from "./modules/InView.js";
import Form from "./modules/Form.js";
import InputValConverter from "./modules/InputValConverter.js";

const includeHeader = fetch('/includes/header.html')
.then((response) => {
  return response.text();
})
.then((data) => {
  const parser = new DOMParser();
  const html = parser.parseFromString(data, "text/html");
  const header = html.querySelector('.site-header');
  document.querySelector('#placeholder-header').replaceWith(header);
});

const includeFooter = fetch('/includes/footer.html')
.then((response) => {
  return response.text();
})
.then((data) => {
  const parser = new DOMParser();
  const html = parser.parseFromString(data, "text/html");
  const header = html.querySelector('.site-footer');
  document.querySelector('#placeholder-footer').replaceWith(header);
});

const generateNewsItems = () => {
  const newsList = document.querySelector('[data-generate-news-items]');
  if (newsList != null) {
    const newsCount = 4
    return fetch('/includes/news.json')
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      let newsItems = '';
      const now = new Date();
      data.forEach((d, i) => {
        if (i < newsCount) {
          const date = new Date(d.date)
          const isNew = now.getTime() - date.getTime() <= 1000 * 60 * 60 * 24 * 7;
          const dateHtml = `<time datetime="${d.date}" class="news__date">${d.date}</time>`;
          const categoryHtml = d.category ? `<span class="news__category-tag">${d.category}</span>` : '';
          const newHtml = isNew ? `<span class="news__new-tag">NEW</span>` : '';
          const linkTargetHTML = d.target ? ` target="${d.target}"` : '';
          const linkHtml = `<a href="${d.url}"${linkTargetHTML} class="news__link"><span class="news__text">${d.text}</span></a>`
          newsItems += `<li class="news__item">${dateHtml}${newHtml}${categoryHtml}${linkHtml}</li>`
        } else {
          return false;
        }
      });
      newsList.innerHTML = newsItems;
    });
  }
}

Promise.all([
  includeHeader,
  includeFooter,
  generateNewsItems()
])
.then(() => {
  document.body.classList.add('_is_loaded');
  new ScrolledToggleElement();
  new SmoothScroll();
  // new TrimmingTexts();
  const menu = new Menu();
  window.addEventListener("pageshow", function(event){
    if (event.persisted) {
      menu.init()
    }
  });
})

new Tab();
new Modal();
new News();
const form = new Form();
new InputValConverter();
if (document.querySelector('.site-body__bg') != null) {
  new SetCssCustomProperties();
};

window.addEventListener('load', () => {
  new InView();
});

window.addEventListener("pageshow", function(event){
  form.checkFormValidity();
});